(function(){
'use strict';
/*
 * Fix: the theme's native header cart price span (.t4s-h-cart__total)
 * is not touched by the unified cart drawer (divarouj-cart-stable.js),
 * which only updates item-count badges, not price text. That left the
 * header total frozen at its page-load value (e.g. still 'LE 0.00')
 * after items were added, changed, or removed via the drawer, while the
 * count badge next to it updated correctly. This listens for the same
 * cart:updated / cart:refresh events divarouj-cart-stable.js already
 * dispatches after every cart change and keeps that price in sync,
 * without touching the existing cart engine.
 */
 function applyTotal(el, cents) {
   var match = (el.textContent || '').match(/^[^0-9]*/);
   var prefix = match ? match[0] : 'LE ';
   el.textContent = prefix + (Number(cents || 0) / 100).toFixed(2);
 }
 function sync(cart) {
   var els = document.querySelectorAll('.t4s-h-cart__total');
   if (!els.length) return;
   if (cart && typeof cart.total_price === 'number') {
     els.forEach(function (el) {
       if (el.closest('#divaStableCart')) return;
       applyTotal(el, cart.total_price);
     });
     return;
   }
   var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
   fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
     .then(function (r) { return r.json(); })
     .then(function (data) {
       els.forEach(function (el) {
         if (el.closest('#divaStableCart')) return;
         applyTotal(el, data.total_price);
       });
     })
     .catch(function () {});
 }
 document.addEventListener('cart:updated', function (e) { sync(e && e.detail); });
 document.addEventListener('cart:refresh', function (e) { sync(e && e.detail); });
})();
